import Repository from './Repository';

const resource = 'api/telemeter';

export default {
  get({ pathParams, queryParams }:
    {
      pathParams: {
        target: 'damgauge' | 'wlevelgauge',
      },
      queryParams: {
        id: string,
        // eslint-disable-next-line camelcase
        date_time: string,
        hours: number,
        interval: string,
      }
    }): Promise<any> {
    return Repository.get(`${resource}/${pathParams.target}?id=${queryParams.id}&date_time=${queryParams.date_time}&hours=${queryParams.hours}&interval=${queryParams.interval}`);
  },
};
